import { render, staticRenderFns } from "./lot.vue?vue&type=template&id=4203cbc2&scoped=true&"
import script from "./lot.vue?vue&type=script&lang=js&"
export * from "./lot.vue?vue&type=script&lang=js&"
import style0 from "./lot.vue?vue&type=style&index=0&id=4203cbc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4203cbc2",
  null
  
)

export default component.exports